import { render } from "./OnboardingCareseeker.vue?vue&type=template&id=3a32866e&scoped=true"
import script from "./OnboardingCareseeker.vue?vue&type=script&lang=js"
export * from "./OnboardingCareseeker.vue?vue&type=script&lang=js"

import "./OnboardingCareseeker.vue?vue&type=style&index=0&id=3a32866e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a32866e"]])

export default __exports__